export const WHOLESALE_ELIGIBLE_VERTICALS = new Set(['Apparel & Footwear']);
export const WHOLESALE_ELIGIBLE_SEGMENTS = new Set([
    'Fashion/Apparel Retailing',
    'Footwear Retailing',
]);
